import React, { useMemo, useState, Fragment } from 'react';
import ExpandedRow from './ExpandedRow';
// Import React Table
import { useTable, useResizeColumns, useFlexLayout } from 'react-table';
import Button from '@hubins/components/Button';
import './index.scss';

const MAX_ITEMS_PER_PAGE = 10;
const EMPTY_PAGE_SIZE = 3;


const ExpandableTable = (props) => {

  const [expandedRow, setExpandedRow] = useState(null);

  let pageSize = EMPTY_PAGE_SIZE;
  if (props.showPagination && props.data.length >= MAX_ITEMS_PER_PAGE) {
    pageSize = MAX_ITEMS_PER_PAGE;
  } else if (props.data.length < MAX_ITEMS_PER_PAGE) {
    pageSize = props.data.length;
  }

  const columns = useMemo(() => [{Header: '', accessor: 'expander', width: props.expandColumnWidth ? props.expandColumnWidth : 60, Cell: ({row}) => {
    if (row.original.noExpand) {
      return <></>;
    }
    return (
      <div className="">
        <Button
          onClick={() => setExpandedRow(expandedRow === row.index ? null : row.index)}
          icon={
            expandedRow === row.index ? "arrow up 1" : "arrow down 1"
          }
          iconColor="primary"
          onlyIcon={true}
          className="white"
        />
      </div>
    );
  }}, ...props.headers], [props.headers, expandedRow]);
  const data = useMemo(() => props.data.map((row => {
    return {
      ...row,
      expander: '',
    };
  })), [props.data]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    footerGroups,
  } = useTable({
    columns,
    data,
  },
  useResizeColumns,
  useFlexLayout);

  return (
    <div className={`table__wrapper ${props.className || ''}`}>
      <table {...getTableProps} className="table">
        <thead>
          {headerGroups.map((headerGroup, index) => (
            <tr {...headerGroup.getHeaderGroupProps()} key={`expandable-row-header-tr-${index}`}>
              {headerGroup.headers.map((column, subIndex) => (
                <th {...column.getHeaderProps()} key={`expandable-row-header-th-${subIndex}`}>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, index) => {
            prepareRow(row);
            const isExpanded = expandedRow === index;
            const className = row.original.className || '';
            return (
              <Fragment key={`expandable-row-body-tr-${index}`}>
              <tr {...row.getRowProps()} className={className} key={`expandable-row-body-tr-${index}`}>

                {row.cells.map((cell, subIndex) => {
                  return (
                    <td {...cell.getCellProps()} className="flex-horizontal-center" key={`expandable-row-body-td-${subIndex}`}>{cell.render('Cell')}</td>
                  );
                })}
              </tr>
              <ExpandedRow
                row={row.original}
                component={props.component}
                colSpan={columns.length + 1}
                isExpanded={isExpanded}
                />
              </Fragment>
            );
          })}
        </tbody>
        {(props.footer) && (
          <tfoot>
            {footerGroups.map((footerGroup, index) => (
              <tr {...footerGroup.getFooterGroupProps()} key={`expandable-row-footer-tr-${index}`}>
                {footerGroup.headers.map((column, subIndex) => (
                  <td {...column.getFooterProps()} key={`expandable-row-footer-td-${subIndex}`}>{column.render('Footer')}</td>
                ))}
              </tr>
            ))}
          </tfoot>
        )}
      </table>
    </div>
  );

};

export default ExpandableTable;
